/* eslint-disable @typescript-eslint/no-explicit-any */

export enum LogSeverity {
  Debug = '0-Debug',
  Info = '1-Info',
  Notice = '2-Notice',
  Warning = '3-Warning',
  Error = '4-Error',
  Critical = '5-Critical',
  Alert = '6-Alert',
  Emergency = '7-Emergency',
}

export interface Log extends LogDeviceInfo {
  flow: string
  severity: LogSeverity
  eventDate?: number
  charityId?: string
  contractId?: string
  operatorId?: string
  username?: string
  event?: string
  errorName?: string
  errorMessage?: string
  details?: {
    error?: any
    stacktrace?: string
    [key: string]: any
  }
  page?: string
}

export interface LogDeviceInfo {
  device?: string
  deviceBrand?: string
  deviceId?: string
  deviceType?: string
  deviceFingerprint?: string
  systemName?: string
  systemVersion?: string
  appVersion?: string
  memoryUsed?: number
  totalMemory?: number
  location?: GpsLocation
}

export interface GpsLocation {
  latitude: number
  longitude: number
  accuracy: number | null
  altitude: number | null
  heading: number | null
  speed: number | null
  altitudeAccuracy?: number | null
  timestamp: number
  mocked?: boolean
  provider?: 'fused' | 'gps' | 'network' | 'passive'
}
export interface UsageAction {
  name: string
  value?: any
}
